module.exports = __webpack_public_path__ + "img/reg-type.6453ed85.svg";